import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';

interface TermsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function TermsModal({ open, onOpenChange }: TermsModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[80vh]">
        <DialogHeader>
          <DialogTitle className="text-2xl">이용약관</DialogTitle>
          <DialogDescription>
            ALT Generation 서비스 이용약관을 확인해주세요. (시행일: 2026년 4월 1일)
          </DialogDescription>
        </DialogHeader>
        <div className="overflow-y-auto max-h-[60vh] pr-4">
          <div className="space-y-6 text-sm">

            {/* 사업자 정보 */}
            <section className="bg-gray-50 p-4 rounded-lg">
              <h3 className="font-bold text-base mb-2">사업자 정보 (전자상거래법 제10조)</h3>
              <div className="text-gray-700 space-y-1 leading-relaxed">
                <p>• <strong>상호:</strong> 지호아이앤씨 (이하 "회사")</p>
                <p>• <strong>서비스명:</strong> ALT Generation</p>
                <p>• <strong>대표자:</strong> 최정윤</p>
                <p>• <strong>소재지:</strong> 서울 중구 다산로 106 (신당동, 한두빌딩) 5층</p>
                <p>• <strong>이메일:</strong> ibjun77@gmail.com</p>
                <p>• <strong>전화:</strong> 02-2636-4664</p>
                <p>• <strong>서비스 URL:</strong> https://alt.aigeneration-tech.com</p>
              </div>
            </section>

            <section>
              <h3 className="font-bold text-base mb-2">제1조 (목적)</h3>
              <p className="text-gray-700 leading-relaxed">
                본 약관은 지호아이앤씨(이하 "회사")이 운영하는 ALT Generation 웹사이트(https://alt.aigeneration-tech.com, 이하 "서비스")를 이용함에 있어 회사와 이용자 간의 권리, 의무, 접임사항 및 서비스 이용에 관한 조건을 규정함을 목적으로 합니다.
              </p>
            </section>

            <section>
              <h3 className="font-bold text-base mb-2">제2조 (정의)</h3>
              <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
                <li>"서비스"란 회사가 제공하는 AI 기반 이미지 ALT 텍스트 자동 생성 SaaS(Software as a Service) 관련 제반 서비스를 의미합니다.</li>
                <li>"이용자"란 본 약관에 따라 서비스를 이용하는 회원 및 비회원을 말합니다.</li>
                <li>"회원"이란 회사와 이용계약을 체결하고 계정을 부여받은 자를 말합니다.</li>
                <li>"무료 회원"이란 유료 요금제에 가입하지 않은 회원으로, 무료 플랜 한도 내에서 서비스를 이용하는 자를 말합니다.</li>
                <li>"유료 회원"이란 회사가 정한 유료 요금제에 가입하여 이용료를 납부하고 서비스를 이용하는 회원을 말합니다.</li>
                <li>"ALT 텍스트"란 이미지에 대한 접근성 및 SEO 목적의 대체 텍스트 설명을 의미합니다.</li>
                <li>"API 키"란 회사가 제공하는 Open API를 이용하기 위해 발급되는 인증 코드를 의미하며, 스타트(Starter) 플랜 이상의 회원에게만 발급됩니다.</li>
                <li>"요금제"란 회사가 제공하는 서비스 이용 등급으로, 무료(Free), 스타트(Starter), 프로(Professional), 엔터프라이즈(Enterprise) 플랜으로 구성됩니다.</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base mb-2">제3조 (약관의 효력 및 변경)</h3>
              <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
                <li>본 약관은 서비스 화면에 게시하거나 이용자에게 공지하는 시점부터 효력이 발생합니다.</li>
                <li>회사는 관련 법령을 위반하지 않는 범위에서 본 약관을 변경할 수 있으며, 변경 시 적용일자 및 변경사유를 명시하여 7일 이전(이용자에게 불리한 변경의 경우 30일 이전)에 서비스 공지사항, 이메일 등을 통해 공지합니다.</li>
                <li>이용자가 변경된 약관에 동의하지 않는 경우 서비스 이용을 중단하고 이용계약을 해지할 수 있습니다. 변경 이후에도 서비스를 계속 이용하면 변경에 동의한 것으로 봅니다.</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base mb-2">제4조 (서비스의 제공)</h3>
              <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
                <li>회사는 다음과 같은 서비스를 제공합니다.
                  <ul className="list-disc list-inside ml-4 mt-1 space-y-1">
                    <li>웹사이트 URL 크롤링을 통한 이미지 수집 및 ALT 텍스트 자동 생성</li>
                    <li>이미지 URL 직접 입력을 통한 ALT 텍스트 생성</li>
                    <li>이미지 이미지 업로드를 통한 ALT 텍스트 생성</li>
                    <li>생성된 ALT 텍스트 조회·수정·관리 및 이력 제공</li>
                    <li>Open API를 통한 외부 시스템 연동 서비스</li>
                    <li>기타 회사가 추가하거나 제휴를 통해 제공하는 서비스</li>
                  </ul>
                </li>
                <li>서비스는 연중무휴 24시간 제공을 원칙으로 하나, 시스템 점검·장애·개선 작업 등의 경우 일시적으로 중단될 수 있습니다. 예정된 점검은 사전에 공지합니다.</li>
                <li>회사는 서비스 운영상 필요한 경우, 사전 고지 후 서비스의 내용을 변경하거나 종료할 수 있습니다.</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base mb-2">제5조 (회원가입 및 계약의 성립)</h3>
              <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
                <li>이용자는 회사가 정한 가입 양식에 따라 정보를 기입하고 본 약관 및 개인정보처리방침에 동의함으로써 회원가입을 신청합니다.</li>
                <li>다음 각 호에 해당하는 신청은 승낙을 거부하거나 사후에 이용계약을 해지할 수 있습니다.
                  <ul className="list-disc list-inside ml-4 mt-1 space-y-1">
                    <li>이전에 본 약관에 의해 회원자격을 상실한 적이 있는 경우</li>
                    <li>타인의 명의를 도용하거나 허위 정보를 등록한 경우</li>
                    <li>만 14세 미만인 경우</li>
                    <li>기타 회사의 기술·운영상 이유로 승낙이 어려운 경우</li>
                  </ul>
                </li>
                <li>회원가입 계약은 회사의 승낙의사가 이용자에게 도달한 시점에 성립합니다.</li>
                <li>탈퇴한 회원은 탈퇴일로부터 30일이 경과한 후 동일 이메일로 재가입이 가능합니다.</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base mb-2">제6조 (계정 관리)</h3>
              <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
                <li>회원은 아이디와 비밀번호를 직접 관리해야 하며, 제3자에게 양도하거나 이용하게 할 수 없습니다.</li>
                <li>계정 정보 유출, 도용, 무단 사용 등을 인지한 경우 즉시 회사에 신고하고 안내에 따라야 합니다.</li>
                <li>회원의 관리 소홀로 인한 피해에 대해 회사는 책임을 지지 않습니다.</li>
                <li>회원은 프로필관리에서 언제든지 개인정보를 열람하고 수정할 수 있습니다.</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base mb-2">제7조 (유료 서비스 및 요금제)</h3>
              <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
                <li>서비스는 다음 요금제로 제공되며, 요금 및 제공 내용은 회사 사정에 따라 변경될 수 있습니다.
                  <ul className="list-disc list-inside ml-4 mt-1 space-y-1">
                    <li>무료(Free): 월 최대 60건, 일 최대 20건 ALT 텍스트 생성 가능. API 키 발급 불가.</li>
                    <li>스타트(Starter): 월 최대 500건. API 키 발급 가능. 월 ₩15,000.</li>
                    <li>프로(Professional): 월 최대 2,000건. API 키 발급 가능. 월 ₩29,000.</li>
                    <li>엔터프라이즈(Enterprise): 월 최대 10,000건. API 키 발급 가능. 별도 문의.</li>
                  </ul>
                </li>
                <li>유료 서비스는 선납제를 원칙으로 하며, 월간 요금은 계좌이체(무통장입금) 방식으로 결제합니다. 입금 확인 후 관리자가 플랜을 활성화합니다.</li>
                <li><strong>API 키:</strong> API 키를 통한 외부 시스템 연동은 스타트(Starter) 플랜 이상에서만 이용 가능합니다.</li>
                <li><strong>요금제 업그레이드:</strong> 유료 플랜 업그레이드 요청 후 회사 지정 계좌로 입금 시, 관리자 확인 후 플랜이 적용됩니다.</li>
                <li><strong>요금제 다운그레이드:</strong> 다운그레이드는 월 1회로 제한되며, 신청 다음 달 1일부터 변경된 요금제가 적용됩니다. 다운그레이드 신청 취소는 적용일 전까지 가능합니다.</li>
                <li>회사는 요금제 변경 시 최소 30일 전 이메일 또는 서비스 공지를 통해 안내합니다.</li>
                <li>API 사용량이 요금제 한도를 초과하는 경우 서비스 이용이 제한될 수 있습니다.</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base mb-2">제8조 (결제 방식)</h3>
              <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
                <li>현재 결제 방식은 계좌이체(무통장입금)이며, 입금 확인 후 관리자가 플랜을 활성화합니다. 향후 카드 자동결제 방식이 추가될 수 있습니다.</li>
                <li>결제 계좌 정보는 요금제 업그레이드 신청 시 이메일 또는 서비스 화면을 통해 안내됩니다.</li>
                <li>입금 후 영업일 기준 1일 이내 플랜이 적용되지 않는 경우 이메일(ibjun77@gmail.com)로 문의하시기 바랍니다.</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base mb-2">제9조 (서비스 이용의 제한 및 중지)</h3>
              <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
                <li>회사는 전시, 사변, 천재지변 또는 이에 준하는 국가비상사태가 발생하거나 발생할 우려가 있는 경우와 전기통신사업법에 의한 기간통신사업자가 전기통신서비스를 중지하는 등 부득이한 사유가 있는 경우에는 서비스의 전부 또는 일부를 제한하거나 중지할 수 있습니다.</li>
                <li>회사는 이용자가 본 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 경고, 일시정지, 영구이용정지 등으로 서비스 이용을 단계적으로 제한할 수 있습니다.</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base mb-2">제10조 (청약철회 및 환불 정책)</h3>
              <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
                <li>회원은 유료 서비스 결제 후 서비스를 사용하지 않은 상태(ALT 텍스트 생성, API 호출 등 미사용)라면 결제일로부터 7일 이내에 청약철회(결제 취소)를 요청할 수 있습니다.</li>
                <li>다음 각 호에 해당하는 경우 청약철회 및 환불이 제한됩니다.
                  <ul className="list-disc list-inside ml-4 mt-1 space-y-1">
                    <li>결제 후 ALT 텍스트 생성, API 호출 등 서비스를 1회라도 이용한 경우</li>
                    <li>결제일로부터 7일이 경과한 경우</li>
                    <li>이용자의 단순 변심 또는 요금제 내용 미확인으로 인한 경우</li>
                    <li>프로모션·이벤트 등을 통해 무상으로 취득한 유료 서비스</li>
                  </ul>
                </li>
                <li>구독 해지 시 이미 결제된 기간의 잔여 서비스는 이용기간 종료까지 유지되며, 잔여 기간에 대한 환불은 제공되지 않습니다.</li>
                <li>회사의 귀책사유로 인한 서비스 장애(24시간 이상 지속 장애)의 경우 장애 기간에 비례한 이용기간 연장 또는 환불이 제공될 수 있습니다.</li>
                <li>환불 문의는 이메일(ibjun77@gmail.com)로 신청하며, 회사는 수령일로부터 3영업일 이내에 처리합니다.</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base mb-2">제11조 (서비스 이용 시간 및 장애)</h3>
              <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
                <li>서비스는 연중무휴 24시간을 원칙으로 하나, 다음의 경우 사전·사후 고지 후 중단될 수 있습니다.
                  <ul className="list-disc list-inside ml-4 mt-1 space-y-1">
                    <li>시스템 정기점검, 업그레이드, 긴급 보안 패치</li>
                    <li>서버·네트워크 장애, 천재지변, 국가 비상사태</li>
                    <li>외부 AI 서비스 제공사(OpenAI 등) 장애</li>
                  </ul>
                </li>
                <li>회사는 서비스 중단으로 인한 손해에 대해, 회사의 고의 또는 중과실이 없는 한 책임을 지지 않습니다.</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base mb-2">제12조 (이용자 금지행위)</h3>
              <p className="text-gray-700 leading-relaxed mb-2">이용자는 다음 행위를 하여서는 안 됩니다.</p>
              <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
                <li>회원가입 또는 서비스 이용 시 허위 정보 등록</li>
                <li>타인의 계정 정보 도용 또는 무단 사용</li>
                <li>서비스를 이용하여 타인의 저작권, 초상권, 개인정보를 침해하는 행위</li>
                <li>유해 콘텐츠(음란물, 폭력, 혐오 등)가 포함된 이미지를 업로드하거나 크롤링하는 행위</li>
                <li>크롤링 시 대상 사이트의 robots.txt 규정을 무시하거나, 과도한 트래픽으로 해당 사이트에 피해를 주는 행위</li>
                <li>API 키를 무단으로 공유하거나 제3자에게 양도·판매하는 행위</li>
                <li>서비스의 소스코드 역공학, 취약점 탐색, 무단 크롤링 등 시스템을 해치는 행위</li>
                <li>자동화 프로그램을 이용하여 요금제 한도를 초과하거나 서비스를 남용하는 행위</li>
                <li>기타 법령, 본 약관, 공서양속에 반하는 행위</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base mb-2">제13조 (계약해지 및 회원탈퇴)</h3>
              <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
                <li>회원은 회원탈퇴 메뉴 또는 이메일을 통해 언제든지 탈퇴를 신청할 수 있습니다.</li>
                <li>유료 구독 중인 회원이 탈퇴하는 경우 구독은 즉시 해지되며, 잔여 기간에 대한 환불은 제공되지 않습니다.</li>
                <li>탈퇴 후 1년간 회원의 데이터(ALT 텍스트 이력, API 키 등)가 보존되며, 이 기간 내에 탈퇴를 취소하고 계정을 복구할 수 있습니다. 1년 경과 후에는 모든 데이터가 자동 삭제되며 복구되지 않습니다. 단, 관계 법령에 의해 보존이 요구되는 정보는 해당 기간 동안 별도 보관됩니다.</li>
                <li>탈퇴 후 1년 이내에는 이메일을 통해 탈퇴를 취소하고 계정을 복구할 수 있습니다.</li>
                <li>탈퇴한 회원은 탈퇴일로부터 30일이 경과한 후 동일 이메일로 재가입이 가능합니다.</li>
                <li>회사는 다음 각 호에 해당하는 경우 이용계약을 해지하거나 서비스 이용을 제한할 수 있습니다.
                  <ul className="list-disc list-inside ml-4 mt-1 space-y-1">
                    <li>본 약관의 금지행위를 한 경우</li>
                    <li>이용요금을 30일 이상 연체한 경우</li>
                    <li>서비스를 불법적 목적으로 이용한 경우</li>
                  </ul>
                </li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base mb-2">제14조 (면책조항)</h3>
              <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
                <li>천재지변, 전쟁, 테러, 해킹 등 불가항력으로 인한 서비스 중단에 대해 회사는 책임을 지지 않습니다.</li>
                <li><strong>AI 생성 결과물:</strong> 본 서비스는 AI 모델을 활용하므로 생성된 ALT 텍스트의 정확성, 완전성, 적합성을 보증하지 않습니다. 최종 검토 및 수정은 이용자의 책임입니다.</li>
                <li>이용자가 크롤링하는 외부 웹사이트의 저작권 침해, 이용약관 위반 등에 대한 법적 책임은 이용자에게 있습니다.</li>
                <li>이용자가 서비스에 업로드한 이미지의 저작권, 초상권, 개인정보 등에 관한 책임은 이용자에게 있습니다.</li>
                <li>외부 AI 서비스(OpenAI 등)의 장애·정책 변경으로 인한 서비스 중단 또는 품질 저하에 대해 회사는 책임을 지지 않습니다.</li>
                <li>무료 서비스 이용과 관련하여 발생하는 손해에 대해, 회사의 고의 또는 중과실이 없는 한 책임을 지지 않습니다.</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base mb-2">제15조 (분쟁 해결)</h3>
              <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
                <li>서비스 이용과 관련한 분쟁은 먼저 이메일(ibjun77@gmail.com)을 통해 쌍방 합의로 해결합니다.</li>
                <li>합의가 이루어지지 않을 경우 소비자분쟁조정위원회 등 관련 기관의 조정에 따를 수 있습니다.</li>
              </ol>
            </section>

            <section>
              <h3 className="font-bold text-base mb-2">제16조 (준거법 및 재판관할)</h3>
              <ol className="list-decimal list-inside space-y-2 text-gray-700 leading-relaxed">
                <li>본 약관과 관련된 사항에 대하여는 대한민국 법을 준거법으로 합니다.</li>
                <li>서비스 이용으로 발생한 분쟁에 대해 소송이 제기되는 경우 회사의 본사 소재지를 관할하는 법원을 전속 관할 법원으로 합니다.</li>
              </ol>
            </section>

            <div className="pt-4 border-t mt-6 space-y-1">
              <p className="text-gray-600 text-xs">공고일자: 2026년 3월 27일</p>
              <p className="text-gray-600 text-xs">시행일자: 2026년 4월 1일</p>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
